import { ChromeOutlined, CodeOutlined, ControlOutlined, DatabaseOutlined, HomeOutlined, ProfileOutlined } from "@ant-design/icons";

export const siderMenus: {
  path: string;
  title: string;
  icon?: React.ReactElement,
}[] = [
  {
    title: '工作台',
    path: '/',
    icon: <HomeOutlined />,
  },
  {
    title: '运行环境',
    path: '/sessions',
    icon: <ChromeOutlined />,
  },
  {
    title: '浏览器控制台',
    path: '/control',
    icon: <ControlOutlined />,
  },
  {
    title: '自动化脚本',
    path: '/actions',
    icon: <CodeOutlined />,
  },
  {
    title: '资源变量',
    path: '/resources',
    icon: <DatabaseOutlined />,
  },
  {
    title: '运行记录',
    path: '/script-result',
    icon: <ProfileOutlined />,
  },
];
